module.exports = __webpack_public_path__ + "static/media/react.638be909.png";